<template>
  <div class="d-flex justify-center">
    <div class="container">
      <h1>{{ contact.title }}</h1>
      <p class="py-5" v-html="contact.text"></p>
      <v-btn rounded color="#ef6758" class="call2action" :to="{path: '/contact'}">
        {{ contact.call2action}}
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters('strapiv2', ['contact'])
  }
}
</script>

<style scoped>
.container {
  text-align: center;
  max-width: 800px;
}
.call2action {
  color: white;
}
</style>